import React, { useState } from 'react';
import { APP_CONST } from '../../constants';
import { GeckoCard, GeckoAlert, GeckoBtn } from '../../components';
import { $state, $stateParams } from '../../router';
import { Auth, ClientManager } from '../../services';
import ProfileSelector from '../../components/ProfileSelector';
import ErrorTracker from '../../services/ErrorTracker';


const SelectProfile = (props) => {
    const [error, setError] = useState(null);
    const client = ClientManager.client() || 'web';
    const app = ClientManager.app();

    const enableAutoRedirect = ($stateParams.ar && $stateParams.ar === 'false' ? false : true);

    const onSelectProfile = (profile) => {
        if (!profile) {
            throw new Error('Expected ProfileId');
        }

        return Auth.getRedirectUrl(profile.ProfileId, client, app).then((response) => {
            redirect(response.RedirectUrl);
        }).catch((err) => {
            if (err instanceof Error) {
                ErrorTracker.captureException(err);
                setError(err.message);
            } else if (err.Error) {
                ErrorTracker.captureException(err.Error);
                setError(err.Error);
            } else {
                ErrorTracker.captureException(err);
                setError(err);
            }
        });
    }

    if (error) {
        return (
            <div style={{ margin: '0 15px 15px 15px' }}>
                <GeckoAlert type={APP_CONST.ALERT_TYPE_DANGER}>
                    {error}
                </GeckoAlert>
            </div>
        );
    }

    return(
        <div id="module-select-profile">
            <GeckoCard padded={true}>
                <ProfileSelector 
                    client={client} 
                    app={app} 
                    onSelectProfile={onSelectProfile} 
                    autoRedirect={enableAutoRedirect}
                    onError={(err) => {
                        setError(err.message);
                    }}
                />
            </GeckoCard>

            <LogoutButton />
        </div>
    );

}

const redirect = (redirectUrl) => {
    if (!redirectUrl) {
        throw new Error('Redirect url not found');
    }

    window.location = redirectUrl;
}

const LogoutButton = () => {
    return (
        <div>
            <GeckoBtn
                name="Logout"
                icon={'sign-out-alt'}
                type={APP_CONST.BTN_TYPE_DANGER}
                handler={() => {
                    $state.go('logout', {
                        client: ClientManager.client(),
                        app: ClientManager.app(),
                    });
                }}
                className="float-left"
            />
        </div>
    );
}

export default SelectProfile;
